import React from 'react';
import { ArrowRight } from 'lucide-react';
import SecondaryButton from '../components/SecondaryButton';
import { freeGraceTopics } from '../mock';

const FreeGrace = () => {
  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Free Grace Theology</h1>
        <p className="body-large page-subtitle">
          Salvation by grace alone through faith alone in Christ alone.
        </p>

        <div className="free-grace-intro">
          <h2 className="display-medium section-title">The Free Grace Gospel</h2>
          <p className="body-large">
            Free Grace theology affirms that eternal life is a free, irrevocable gift received 
            by faith alone in Christ alone, apart from works, commitment, or personal merit. 
            Salvation is not a reward for the righteous but a gift for the ungodly who believe 
            (Romans 4:5).
          </p>
        </div>

        <div className="topics-section">
          {freeGraceTopics.map((topic, index) => (
            <div key={index} className="topic-detail-card">
              <h3 className="heading-2">{topic.title}</h3>
              <p className="body-large">{topic.description}</p>
            </div>
          ))}
        </div>

        <div className="comparisons-section">
          <h2 className="display-medium section-title">Faith Alone vs Lordship Salvation</h2>
          
          <div className="comparison-grid">
            <div className="comparison-card free-grace-card">
              <h3 className="heading-2">Free Grace Position</h3>
              <ul className="comparison-list">
                <li className="body-medium">Salvation is by faith alone, apart from works</li>
                <li className="body-medium">Eternal life is a free, irrevocable gift</li>
                <li className="body-medium">Assurance is based on God's promise, not performance</li>
                <li className="body-medium">Discipleship is distinct from salvation</li>
                <li className="body-medium">Rewards are earned; salvation is received</li>
              </ul>
            </div>

            <div className="comparison-card lordship-card">
              <h3 className="heading-2">Lordship Salvation</h3>
              <ul className="comparison-list">
                <li className="body-medium">Requires commitment and surrender for salvation</li>
                <li className="body-medium">Good works are necessary to prove salvation</li>
                <li className="body-medium">Assurance depends on ongoing faithfulness</li>
                <li className="body-medium">Confuses salvation with discipleship</li>
                <li className="body-medium">Blurs the line between gift and reward</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="objections-section">
          <h2 className="display-medium section-title">Common Objections Answered</h2>
          
          <div className="objections-list">
            <div className="objection-card">
              <h3 className="heading-3">James 2: "Faith Without Works is Dead"</h3>
              <p className="body-medium">
                James is addressing the value and evidence of faith in the context of Christian 
                living, not the condition for receiving eternal life. Dead faith is genuine but 
                unproductive faith, not false faith.
              </p>
            </div>

            <div className="objection-card">
              <h3 className="heading-3">Hebrews Warnings</h3>
              <p className="body-medium">
                The warnings in Hebrews concern loss of reward and inheritance, not loss of 
                salvation. Context consistently distinguishes between eternal destiny and 
                temporal consequences.
              </p>
            </div>

            <div className="objection-card">
              <h3 className="heading-3">John 15: "Abide in Me"</h3>
              <p className="body-medium">
                John 15 speaks to fellowship and fruitfulness, not salvation. Branches that don't 
                bear fruit are believers who fail to abide, resulting in discipline and loss of 
                reward.
              </p>
            </div>

            <div className="objection-card">
              <h3 className="heading-3">Matthew 7: "Depart From Me"</h3>
              <p className="body-medium">
                The individuals in Matthew 7:21-23 never believed in Christ for eternal life. 
                They trusted in their works, not in Him. They were never saved.
              </p>
            </div>
          </div>
        </div>

        <div className="section-cta">
          <SecondaryButton to="/articles" icon={ArrowRight}>
            Read In-Depth Articles
          </SecondaryButton>
        </div>
      </section>
    </div>
  );
};

export default FreeGrace;
